import {clsx} from "clsx";
import {twMerge} from "tailwind-merge";

export function cn(...inputs)
{
  return twMerge(clsx(inputs));
}

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames

The classNames function takes any number of arguments which can be a string or object. The argument 'foo' is short for {foo: true}. If the value of the key is falsy, it won't be included in the output.

classNames('foo', 'bar'); // => 'foo bar'
      classNames('foo', { bar: true }); // => 'foo bar'
      classNames({ foo: true }, { bar: true }); // => 'foo bar'
      classNames({ foo: true, bar: true }); // => 'foo bar'

      // lots of arguments of various types
      classNames('foo', { bar: true, duck: false }, 'baz', { quux: true }) // => 'foo bar baz quux'

      // other falsy values are just ignored
      classNames(null, false, 'bar', undefined, 0, 1, { baz: null }, ''); // => 'bar 1'

Arrays will be recursively flattened as per the rules above:

var arr = ['b', { c: true, d: false }];
      classNames('a', ar

*/
const hasOwn = {}.hasOwnProperty;

export function classNames()
{
  let classes = '';

  for ( let i = 0; i < arguments.length; i++ )
  {
    const arg = arguments[i];
    if ( arg )
    {
      classes = appendClass(classes, parseValue(arg));
    }
  }

  return classes;
}

function parseValue(arg)
{
  if ( typeof arg === 'string' )
  {
    return arg;
  }

  if ( typeof arg !== 'object' )
  {
    return '';
  }

  if ( Array.isArray(arg) )
  {
    return classNames.apply(null, arg);
  }

  if ( arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]') )
  {
    return arg.toString();
  }

  let classes = '';

  for ( const key in arg )
  {
    if ( hasOwn.call(arg, key) && arg[key] )
    {
      classes = appendClass(classes, key);
    }
  }

  return classes;
}

function appendClass(value, newClass)
{
  if ( !newClass )
  {
    return value;
  }

  return value ? (value + ' ' + newClass) : newClass;
}